<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <SurveyQuestions />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import SurveyQuestions from "./components/SurveyQuestions";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    SurveyQuestions,
    // ProjectsTable,
  },
};
</script>
